import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureaddFalgExam, successaddFalgExam } from "./AddFalgExamSlice";
import {
  IFalgExam,
  IFalgExamList,
  IFalgExamListSubmission,
} from "../../../Pages/Yearlevel_map/IYearlevel_map";
import { failurelistFlagExam, successlistFlagExam } from "./ListFlagExamSlice";
import {
  failurelistFlagExamSubmission,
  successlistFlagExamSubmission,
} from "./ListFlagExamSubmissionSlice";

// add
const AddFalgExamApi = (action: PayloadAction<IFalgExam>) => {
  return api.post("/api/exam/flag", action.payload);
};

export function* AddFalgExamCall(action: PayloadAction<IFalgExam>) {
  try {
    const response: AxiosResponse = yield call(AddFalgExamApi, action);
    yield put(successaddFalgExam(response.data));
  } catch (error) {
    yield put(failureaddFalgExam(error));
  }
}

// list instruction FalgExamExam
const ListFlagExamApi = (action: PayloadAction<IFalgExamList>) => {
  return api.get("/api/examflag/get", { params: action.payload });
};

export function* ListFlagExamCall(action: PayloadAction<IFalgExamList>) {
  try {
    const response: AxiosResponse = yield call(ListFlagExamApi, action);
    yield put(successlistFlagExam(response.data));
  } catch (error) {
    yield put(failurelistFlagExam(error));
  }
}

// list instruction FalgExamExam
const ListFlagExamSubmissionApi = (
  action: PayloadAction<IFalgExamListSubmission>
) => {
  return api.get("/api/exam_answer/section/submission", {
    params: action.payload,
  });
};

export function* ListFlagExamSubmissionCall(
  action: PayloadAction<IFalgExamListSubmission>
) {
  try {
    const response: AxiosResponse = yield call(
      ListFlagExamSubmissionApi,
      action
    );
    yield put(successlistFlagExamSubmission(response.data));
  } catch (error) {
    yield put(failurelistFlagExamSubmission(error));
  }
}
